"use client";

import Link from "next/link";

import { IcArrowRight } from "@jetblue/kit-icons/ic-arrow-right";

import type { CountdownClockDialog } from "../../../dialogs/nav/countdown-clock";

import { Countdown, useCountdown } from "@jetblue/kit/countdown";

export const CountdownClockClient = ({
  ctaText,
  endDate,
  hoursText,
  href,
  minutesText,
  primaryText,
  secondaryText,
  secondsText,
  showCountdown,
  startDate,
  target,
}: CountdownClockDialog) => {
  const now = Date.now();
  const start = new Date(startDate).getTime();
  const end = new Date(endDate).getTime();

  const shouldShow = start <= now && end >= now;
  if (!shouldShow) {
    return null;
  }

  const { daysAndHours, minutes, seconds, isCountdownComplete } =
    useCountdown(endDate);

  if (isCountdownComplete) {
    return null;
  }

  return (
    <Link
      className="
        flex min-w-80 items-center justify-center gap-2
        bg-background-primary-variant p-1 text-foreground-on-primary

        hover:bg-core-blue/90

        md:gap-6
      "
      data-fs-element="countdown-clock"
      href={href}
      target={target}
    >
      <span className="inline-block gap-2">
        <span
          className="
            text-body-extra-bold

            md:text-s-heading
          "
        >
          {primaryText}
        </span>

        {secondaryText && (
          <span
            className="
              ms-1 hidden text-body

              lg:inline
            "
          >
            &nbsp;{secondaryText}
          </span>
        )}

        <span
          className="
            flex items-center text-legal

            hover:underline

            md:hidden
          "
        >
          {ctaText} <IcArrowRight className="ms-1 size-2" />
        </span>
      </span>

      {showCountdown && (
        <Countdown
          separatorClassName="text-on-primary"
          units={[
            { label: hoursText, value: daysAndHours },
            { label: minutesText, value: minutes },
            { label: secondsText, value: seconds },
          ]}
        />
      )}

      <span
        className="
          hidden items-center

          hover:underline

          md:flex
        "
      >
        {ctaText} <IcArrowRight className="ms-1 size-2" />
      </span>
    </Link>
  );
};
